import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react-lite';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { ScholarshipFundersEntities } from '../../../../../../api/types/settings/scholarship-funders';

interface SelectScholarshipFunderDialogProps {
  visible: boolean;
  onHide: () => void;
  onSelect: (funder: ScholarshipFundersEntities) => void;
}

export const SelectScholarshipFunderDialog: React.FC<SelectScholarshipFunderDialogProps> =
  observer(({ visible, onHide, onSelect }) => {
    const [selectedFunder, setSelectedFunder] =
      useState<ScholarshipFundersEntities | null>(null);

    const handleApprove = () => {
      if (selectedFunder) {
        onSelect(selectedFunder);
        setSelectedFunder(null);
        onHide();
      }
    };

    const handleCancel = () => {
      setSelectedFunder(null);
      onHide();
    };

    return (
      <Dialog
        header="בחירת גורם מממן"
        visible={visible}
        onHide={handleCancel}
        style={{ width: '600px', direction: 'rtl' }}
        modal
        footer={
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '0.5rem',
            }}
          >
            <Button
              label="ביטול"
              icon="pi pi-times"
              severity="secondary"
              text
              onClick={handleCancel}
            />
            <Button
              label="אישור"
              icon="pi pi-check"
              onClick={handleApprove}
              disabled={!selectedFunder}
            />
          </div>
        }
      >
        <DataTable
          value={globalSettingsStores.scholarshipFunders}
          selectionMode="single"
          selection={selectedFunder}
          onSelectionChange={(e) =>
            setSelectedFunder(e.value as ScholarshipFundersEntities)
          }
          dataKey="id"
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו גורמים מממנים</div>
          }
          tableStyle={{ direction: 'rtl' }}
        >
          <Column
            selectionMode="single"
            headerStyle={{ width: '3rem' }}
            style={{ textAlign: 'center' }}
          />
          <Column
            field="funderName"
            header="שם גורם מממן"
            style={{ textAlign: 'right' }}
          />
        </DataTable>
      </Dialog>
    );
  });
